/**
 * Runtime configuration, from Vite env files and never hardcoded.
 *
 * Deliberately smaller than the product console's: there is no `apiKey` here.
 * That field exists there as a local convenience, and a static bundle that can
 * destroy every customer's books must have no way to authenticate except a
 * session obtained by a verified human. Leaving the field out means nobody can
 * reach for it.
 */
export const config = {
  /** Empty string = same-origin `/api/admin`, via the dev proxy or CloudFront. */
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '',
} as const;
